import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Skeleton from '@mui/material/Skeleton';

import { POLICY_ACTIONS, POLICY_PATHS } from '~constants/policies';
import { isEmptyArray } from '~utils/array';
import StoresActions from '~redux/Stores/actions';

import UserPermissions from '../UserPermissions';

import StoreSelector from './components/StoreSelector';
import TimeModifier from './components/TimeModifier';
import { SwitchAuto } from './components/SwitchAuto';
import styles from './styles.module.scss';

function Toolbar() {
  const dispatch = useDispatch();
  const { storeSelected } = useSelector((state) => state.core);
  const { allStores, storeById, allStoresLoading, storeByIdLoading } = useSelector((state) => state.stores);
  const isFirstStoreLoading = useRef(true);
  const isLoading = allStoresLoading || isFirstStoreLoading.current;

  useEffect(() => {
    if (!storeByIdLoading) {
      isFirstStoreLoading.current = false;
    }
  }, [storeByIdLoading]);

  useEffect(() => {
    dispatch(StoresActions.getStoreById(storeSelected));
    if (isEmptyArray(allStores.page)) {
      dispatch(StoresActions.getAllStores());
    }
  }, [dispatch, storeSelected, allStores]);

  return (
    <div className={styles.toolbarContainer}>
      {isLoading ? (
        <>
          {Array.from({ length: 4 }).map((_, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Skeleton key={index} animation="wave" width="100%" height="100%" />
          ))}
        </>
      ) : (
        <>
          <UserPermissions policy={POLICY_PATHS.STORES} actions={[POLICY_ACTIONS.INDEX]}>
            <StoreSelector stores={allStores} storeSelected={storeSelected} />
          </UserPermissions>
          <UserPermissions policy={POLICY_PATHS.STORES} actions={[POLICY_ACTIONS.UPDATE]}>
            <SwitchAuto variant="autoAcceptOrder" />
            <SwitchAuto variant="enabledManualDelivery" />
            <TimeModifier
              deliveryWaitTime={storeById.deliveryWaitTime || 0}
              pickUpWaitTime={storeById.pickUpWaitTime || 0}
            />
          </UserPermissions>
        </>
      )}
    </div>
  );
}

export default Toolbar;
